import React from "react";
import { FormikProps } from "formik";
import "./Comment.scss";

interface CommentProps {
  label: string;
  name: string;
  value: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  formik: FormikProps<any>;
}

const Comment = ({
  label,
  value,
  onBlur,
  error,
  touched,
  name,
  formik,
}: CommentProps) => {
  return (
    <div className="form-groupcomment">
      <label className="comment-label">{label}</label>
      <textarea
        name={name}
        value={value}
        onChange={formik.handleChange}
        className="comment-form-control"
        rows={5}
        onBlur={(e) => formik.handleBlur(e)}
      />
      {touched && error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Comment;
